import { Button } from '@bambi/component-library/src/components/Button/Button';
import { useNavigate } from 'react-router';


interface NotificationItemProps {
  title: string;
  description: string;
  href: string;
}

export const NotificationItem = ({
  title,
  description,
  href,
}: NotificationItemProps) => {
  const navigate = useNavigate();

  return (
    <div className="flex w-full max-w-md bg-white" role="listitem">
      <div className="w-0 flex-1 p-2">
        <div className="flex items-start">
          <div className="flex-1">
            <p className="text-sm font-medium text-gray-900">{title}</p>
            <p className="mt-1 text-sm text-gray-500">{description}</p>
          </div>
        </div>
      </div>
      <div className="mr-2 flex items-center">
        <div>
          <Button
            variant="primary-outline"
            onClick={() => navigate(href)}
            aria-label={`View ${title}`}
          >
            <span className="text-mint">View</span>
          </Button>
        </div>
      </div>
    </div>
  );
};
